import t from "./FindAnythingButton.vue2.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const r = /* @__PURE__ */ o(t, [["__scopeId", "data-v-fe3f47b7"]]);
export {
  r as default
};
